import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataTooltipValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                backgroundColor: {
                    type: 'string',
                    empty: false,
                    mandatory: false
                },
                borderColor: {
                    type: 'string',
                    empty: false,
                    mandatory: false
                },
                borderRadius: {
                    type: 'number',
                    empty: false,
                    mandatory: false
                },
                borderWidth: {
                    type: 'number',
                    empty: false,
                    mandatory: false
                }
            }
        };
    }
}
